import { useEffect, useState } from 'react';

export const Pipeline = () => {
  const [data, setData] = useState<any>({
    bitbucketBranch: '',
    bitbucketBuildNumber: '',
  });

  useEffect(() => {
    import('./pipeline.json').then(d => {
      setData({
        bitbucketBranch: d.bitbucketBranch,
        bitbucketBuildNumber: d.bitbucketBuildNumber,
      });
    });
  }, []);

  const styles: React.CSSProperties = {
    background: 'whitesmoke',
    borderRadius: 2,
    bottom: 22,
    color: 'black',
    fontSize: 12,
    left: 2,
    lineHeight: 1,
    padding: 4,
    paddingBottom: 2,
    position: 'fixed',
    zIndex: 2,
  };
  const env = process.env.NEXT_PUBLIC_ENV || 'production';

  if (['local', 'develop'].includes(env)) {
    return <div style={styles}>{`Build ${data.bitbucketBuildNumber} ${data.bitbucketBranch}`}</div>;
  }
  return null;
};
